import classnames from 'classnames';

import Image from 'molecules/Image';
import Layout2Up from 'molecules/Layout2Up';
import RichText from 'molecules/RichText';

import styles from 'components/GridLeadership/gridleadership.module.scss';

import type { GridLeadershipProps } from 'components/GridLeadership/config';
import type { FC } from 'react';

const GridLeadership: FC<GridLeadershipProps> = ({ heading, image, content }) => (
  <>
    {heading && (
      <div className={styles.headingWrapper}>
        <div className={styles.heading}>{heading}</div>
      </div>
    )}
    <Layout2Up
      classes={{
        wrapper: classnames(styles.compareTwoUp),
        left: classnames(styles.left),
        right: classnames(styles.right),
      }}
      left={
        image?.url && (
          <>
            <div className={styles.compareImage}>
              <Image
                alt={image?.url}
                url={image?.url}
                width={image?.width}
                height={image?.height}
                className={styles.image}
              />
            </div>
          </>
        )
      }
      right={
        <>
          {content?.body && <RichText className={styles.content} content={content.body} />}
          {content?.signature?.url && (
            <Image
              alt={content.signature?.url}
              url={content.signature?.url}
              width={content.signature?.width}
              height={content.signature?.height}
            />
          )}
          {content?.contact && <RichText className={styles.contact} content={content.contact.replace(/\\n/g, '\n')} />}
        </>
      }
    />
  </>
);

export default GridLeadership;
